// extracted by mini-css-extract-plugin
module.exports = {"Content":"productReviews_Content__sIeKk"};